import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Register from "./pages/auth/Register";
import Login from "./pages/auth/Login";
import ForgotPassword from "./pages/auth/ForgotPassword";
import ResetPassword from "./pages/auth/ResetPassword";
import Home from "./pages/Home";
import Profile from "./pages/Profile";
import AuthProvider from "./context/auth";
import PrivateRoute from "./components/PrivateRoute";
import NewEvent from "./pages/NewEvent";
import MyFavorites from "./pages/MyFavorites";
import Ad from "./pages/Event";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Support from "./pages/Support";
import Chat from "./pages/Chat";

import { LoadScript } from "@react-google-maps/api";
import ErrorBoundary from "./components/ErrorBoundary"; // <-- Импортируем ErrorBoundary

// Google Maps libraries
const libraries = ["places"];

function App() {
  return (
    <AuthProvider>
      <LoadScript
        googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
        libraries={libraries}
      >
        <BrowserRouter>
          {/* 
            Flex-контейнер для прижатия футера к низу экрана.
          */}
          <div className="d-flex flex-column min-vh-100">
            <Navbar />

            <ErrorBoundary>
              <div className="flex-grow-1">
                <Routes>
                  {/* Private routes */}
                  <Route element={<PrivateRoute />}>
                    <Route path="/newevent" element={<NewEvent />} />
                    <Route path="/favorites" element={<MyFavorites />} />
                    <Route path="/chat" element={<Chat />} />
                  </Route>

                  {/* Public routes */}
                  <Route path="/auth/register" element={<Register />} />
                  <Route path="/auth/login" element={<Login />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/support" element={<Support />} />
                  <Route path="/auth/forgot-password" element={<ForgotPassword />} />
                  <Route path="/auth/reset-password" element={<ResetPassword />} />
                  <Route path="/profile/:id" element={<Profile />} />
                  <Route path="/:category/:id" element={<Ad />} />
                  <Route path="/" element={<Home />} />
                </Routes>
              </div>
            </ErrorBoundary>

            <Footer />
          </div>
        </BrowserRouter>
      </LoadScript>
    </AuthProvider>
  );
}

export default App;
